import * as TypeGraphQL from "type-graphql";
export var JsonNullValueFilter;
(function (JsonNullValueFilter) {
    JsonNullValueFilter["DbNull"] = "DbNull";
    JsonNullValueFilter["JsonNull"] = "JsonNull";
    JsonNullValueFilter["AnyNull"] = "AnyNull";
})(JsonNullValueFilter || (JsonNullValueFilter = {}));
TypeGraphQL.registerEnumType(JsonNullValueFilter, {
    name: "JsonNullValueFilter",
    description: undefined,
});
//# sourceMappingURL=JsonNullValueFilter.js.map